/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardCancelController', DinghyEventBoardCancelController);

    DinghyEventBoardCancelController.$inject = ['$uibModalInstance', 'entity', '$http', '$timeout'];

    function DinghyEventBoardCancelController($uibModalInstance, entity, $http, $timeout) {
        var vm = this;

        vm.dinghyEvent = entity;
        if (vm.dinghyEvent.canceled) {
            $timeout(function () {
                clear();
            });
        }
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel () {
            vm.eventCanceled = {
                id: vm.dinghyEvent.id,
                managerComment: vm.managerComment
            }
            $http.post('api/board/dinghy-events/cancel/', vm.eventCanceled).then(function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
